import { render, staticRenderFns } from "./ue.vue?vue&type=template&id=25b8a5e5"
import script from "./ue.vue?vue&type=script&lang=js"
export * from "./ue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports